import { useEffect, useState } from "react";
import '../styles/Login.css';
import { useNavigate } from "react-router-dom";
import image from "../assets/Studds.png";
import Studds_Logo from "../assets/Studds_logo_white.png";
import { MdVisibility, MdVisibilityOff} from "react-icons/md";
import ShowSnacker from "./DashBoard/ShowSnacker";
import { normalizeRole } from "../utils/rbac";

function Login() {
  const [EmailAddress, setEmailAddress] = useState('');
  const [Password, setPassword] = useState('');
  const [PasswordHidden, PasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  const [snack, setSnack] = useState({open: false,message: "",type: "info"});
  const ShowSnackbar = (message, type= "info") => {
    setSnack({ open: true, message, type});
  };
  async function handleSubmit(e:any) {
    e.preventDefault();
    // Perform login logic here
    try{
      if(!EmailAddress || !Password) {
        // console.log('Please fill in all fields.');
        ShowSnackbar("Please fill all fields","info");
        return;
      } 
      // console.log(EmailAddress, Password);
      const response = await fetch(`https://devicehub.studds.com/admin/login`, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ emailId: EmailAddress, password: Password }),
    });
    const res = await response.json();
    // console.log("response",res);
    if(response.status === 401){
      ShowSnackbar(res.message,"error");
      return;
    }
    if (response.status === 200) {
      // Login successful, render Login component
      setIsLoggedIn(true);
      const token = res.token;

      // Extract and normalize role
      let extractedRole = res.role || res.user?.role;
      if (!extractedRole && token) {
        try {
          const parts = token.split(".");
          if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1]));
            extractedRole = payload.role || payload.org;
          }
        } catch (e) {
          console.warn("Failed to decode token on login:", e);
        }
      }
      const finalRole = normalizeRole(extractedRole);

      // Store JWT token & Auth flags
      localStorage.setItem("token", token);
      localStorage.setItem("auth", "true");
      localStorage.setItem("userRole", finalRole);
      localStorage.setItem("userEmail", EmailAddress);
      if (res.user?.username) {
        localStorage.setItem("userName", res.user.username);
      }

      // Dispatch event so all components react immediately
      window.dispatchEvent(new CustomEvent("roleChanged", { detail: { role: finalRole } }));

      // STORE REMEMBER ME EMAIL
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", EmailAddress);
      } else {
        localStorage.removeItem("rememberedEmail");
      }

      ShowSnackbar("Login Successful","success");
      // REPLACE HISTORY
      setTimeout(()=>{
        navigate("/dashboard/home", { replace: true });
      }, 1000);
    } else {
      ShowSnackbar("Server Error","error");
      return;
    }
    } catch (error) {
      // console.error('Error during login:', error);
      ShowSnackbar("Error during Login","error");
      return;
    }

  }

  useEffect(() => {
  const rememberedEmail = localStorage.getItem("rememberedEmail");

  if (rememberedEmail) {
    setEmailAddress(rememberedEmail);
    setRememberMe(true);
  }
  }, []);
  return (
    <div className="Login">
       <div id="login-card">
          <div id="login-right"> 
            {/* <img src={Black_bg} alt="Background"/> */}
            <img src={Studds_Logo} width="190px" height="80px" alt="logo" className="studds_logo"/>
            <form onSubmit={handleSubmit}>
              {/* <h3 className="title">Admin Login</h3> <br/> */}
              <label>Email</label> <input type="text" className="login-input" placeholder='Username' value={EmailAddress} onChange={(e) => setEmailAddress(e.target.value)} /> 
              <label>Password</label> 
              <div className="password-wrapper">
                <input className="login-input" type={PasswordHidden ? "text" : "password"} placeholder='Password' value={Password} onChange={(e) => setPassword(e.target.value)} />
                <span className="eye-icon" onClick={()=>PasswordVisible(!PasswordHidden)}> {PasswordHidden ? <MdVisibility size={20}/> : <MdVisibilityOff size={20}/>}</span>
              </div>
              <div className="login-links">
                {/* <a href="/">Remember me <input type="checkbox"/></a> */}
                <label className="remember-me">Remember me <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)}/></label>
                <a href="/forgot" className="forgot-link">Forgot Password?</a>
              </div>
              <button type='submit' className="login-input" id="login-button"> Login </button> 
              
            </form>
          </div>
          <div id="login-left">
            <img src={image} alt="img" className="login-image" ></img>
          </div>
          
        </div>  
      {/* <div id="admin-login">
             
        <div id="secure-login">
          <span>Don't have an account?</span>
          <a href="/signup">Sign up </a>
        </div>
      </div> */}
      <ShowSnacker open={snack.open} message={snack.message} type={snack.type} className="login-snackbar" onClose={() => setSnack(s => ({ ...s, open: false }))}/>
    </div>
  );
}
export default Login;